import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { LocaleService } from '../locale/locale.service';
import { RatingService } from '../rating/rating.service';
import { SharedService } from '../shared/shared.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  public userSubject: BehaviorSubject<any>;
  public user: Observable<any>;
  private $publicToken: BehaviorSubject<string>;
  public publicTokenObs: Observable<string>;
  constructor(
    public http: HttpClient,
    public shared: SharedService,
    public rating: RatingService,
    public locale: LocaleService
  ) {
    //Initiating the Behaviour subject with empty value
    this.userSubject = new BehaviorSubject(JSON.parse(localStorage.getItem('user')));
    this.user = this.userSubject.asObservable();
    this.$publicToken = new BehaviorSubject('');
    this.publicTokenObs = this.$publicToken.asObservable();
  }

  set publicToken(token: string) {
    this.$publicToken.next(token);
  }

  get publicToken() {
    return this.$publicToken.value;
  }

  get userData() {
    // Returning the user data to the pages where it is needed
    return this.userSubject.value;
  }

  getStatus(): Observable<Record<any, any>> {
    return this.http.get(`${environment().api}/auth/fetch/status`).pipe(
      map((res) => {
        const user: Record<any, any> = JSON.parse(localStorage.getItem('user'));
        const status: boolean = res['data']['status'];
        const updatedUserData: Record<any, any> = {
          ...user,
          status
        };
        this.userSubject.next(updatedUserData);
        localStorage.setItem('user', JSON.stringify(updatedUserData));

        return res;
      })
    );
  }

  setStatus(data: Record<any, any>): Observable<Record<any, any>> {
    return this.http.post(`${environment().api}/auth/update/status`, data);
  }

  Login(credential: object): Observable<any> {
    return this.http.post<any>(`${environment().api}/auth/login`, credential).pipe(
      map((response) => {
        if (response && response.token) {
          // Admin -> 0, Estimator -> 1, Evaluator -> 2
          localStorage.setItem('user', JSON.stringify(response));

          //Updating the user data in subject variable
          this.userSubject.next(response);

          this.shared.vinInformation.next(null);

          localStorage.removeItem('isQueryParams');
          this.shared.queryParamCheck.next(null);
        }

        return response;
      })
    );
  }

  Logout() {
    this.rating.ratingSaved.next(true);

    //Removing user data from localstorage
    localStorage.removeItem('user');
    this.userSubject.next(null);

    // Resetting the locale
    localStorage.removeItem('locale');
    this.locale.localeSubject.next('en');

    // Resetting the Vehicle Id
    localStorage.removeItem('vehicleId');
    this.shared.vehicle_id.next(null);

    // Resetting the VIN Information
    localStorage.removeItem('vinInfo');
    this.shared.vinInformation.next(null);

    // Resetting the Options
    localStorage.removeItem('options');
    this.shared.options.next(null);

    // Resetting the Flags
    localStorage.removeItem('flags');
    this.shared.flags.next(null);

    // Resetting the Overall data
    localStorage.removeItem('overall');
    this.shared.overall.next(null);

    // Resetting the Severity data
    localStorage.removeItem('severity');
    this.shared.severity.next(null);

    localStorage.removeItem('isQueryParams');
    this.shared.queryParamCheck.next(null);
  }
}
